export var ReleaseVersion;
(function (ReleaseVersion) {
    /**
     * @returns
     * * `-1` if `a` is older than `b`.
     * * `0` if `a` is the same as `b`.
     * * `1` if `a` is newer than `b`.
     */
    function cmp(a, b) {
        return Math.sign(Number(a.slice(2)) - Number(b.slice(2)));
    }
    ReleaseVersion.cmp = cmp;
    /**
     * @returns `true` if `version` is newer than `since` (inclusive) and older
     * than `until` (exclusive)
     */
    function isBetween(version, since, until) {
        return cmp(version, since) >= 0 && cmp(version, until) < 0;
    }
    ReleaseVersion.isBetween = isBetween;
})(ReleaseVersion || (ReleaseVersion = {}));
export var PackMcmeta;
(function (PackMcmeta) {
    function assert(data) {
        const format = data?.pack?.pack_format?.toString();
        if (!format) {
            throw new Error('“pack.pack_format” undefined');
        }
    }
    PackMcmeta.assert = assert;
})(PackMcmeta || (PackMcmeta = {}));
//# sourceMappingURL=common.js.map